module.exports = __webpack_public_path__ + "img/brokers-bg-image.6b7efc77.jpg";